import { useCallback, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import LoadingSpinner from "../../components/Visuals"
import MarketTable from '../../components/MarketTable'
import { config } from './marketPageUserProcessData'
import getUrl from '../../tools/get-domain'
import * as calculates from '../../tools/market/total/calculates'

export default function MarketPageUser() {
    const [rows, setRows] = useState([])
    const [items, setItems] = useState([])
    const [hasMore, setHasMore] = useState(true)
    const [error, setError] = useState(null)

    const updateRows = () => {
        setItems([...items, ...rows.slice(items.length, items.length + 100)])
        if (items.length === rows.length) {
            setHasMore(false)
        }
    }

    async function fetchData() {
        const response = await fetch(getUrl().REACT_APP_MARKET_USERS)
        let data_list = await response.json()
        data_list = data_list.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))

        localStorage.setItem('market_users', JSON.stringify(data_list))
        return data_list

    }

    const convertLocalStorageToRealData = (data) => {
        data.forEach((d) => {
            d['date'] = d['d']
            d['close'] = d['c']
            d['types'] = d['t']
            d['cloud'] = d['cl']
            d['per_buy_5'] = d['pb5']
            d['per_sell_5'] = d['ps5']
            d['per_buy_22'] = d['pb22']
            d['per_sell_22'] = d['ps22']
            d['power_buy'] = d['pb']
            d['entry_money'] = d['em']
            d['entry_money_avg_5'] = d['ema5']
            d['entry_money_avg_22'] = d['ema22']
            d['entry_money_avg_60'] = d['ema60']


            d['per_buy_5']['stock_rights'] = d['per_buy_5']['sr']
            d['per_buy_5']['stock_rights_fund'] = d['per_buy_5']['srf']
            d['per_buy_5']['fund_fixed'] = d['per_buy_5']['ff']

            d['per_sell_5']['stock_rights'] = d['per_sell_5']['sr']
            d['per_sell_5']['stock_rights_fund'] = d['per_sell_5']['srf']
            d['per_sell_5']['fund_fixed'] = d['per_sell_5']['ff']

            d['per_buy_22']['stock_rights'] = d['per_buy_22']['sr']
            d['per_buy_22']['stock_rights_fund'] = d['per_buy_22']['srf']
            d['per_buy_22']['fund_fixed'] = d['per_buy_22']['ff']

            d['per_sell_22']['stock_rights'] = d['per_sell_22']['sr']
            d['per_sell_22']['stock_rights_fund'] = d['per_sell_22']['srf']
            d['per_sell_22']['fund_fixed'] = d['per_sell_22']['ff']

            d['power_buy']['stock_rights'] = d['power_buy']['sr']
            d['power_buy']['stock_rights_fund'] = d['power_buy']['srf']
            d['power_buy']['fund_fixed'] = d['power_buy']['ff']

            d['entry_money']['stock_rights'] = d['entry_money']['sr']
            d['entry_money']['stock_rights_fund'] = d['entry_money']['srf']
            d['entry_money']['fund_fixed'] = d['entry_money']['ff']

            d['entry_money_avg_5']['stock_rights'] = d['entry_money_avg_5']['sr']
            d['entry_money_avg_5']['stock_rights_fund'] = d['entry_money_avg_5']['srf']
            d['entry_money_avg_5']['fund_fixed'] = d['entry_money_avg_5']['ff']

            d['entry_money_avg_22']['stock_rights'] = d['entry_money_avg_22']['sr']
            d['entry_money_avg_22']['stock_rights_fund'] = d['entry_money_avg_22']['srf']
            d['entry_money_avg_22']['fund_fixed'] = d['entry_money_avg_22']['ff']

            d['entry_money_avg_60']['stock_rights'] = d['entry_money_avg_60']['sr']
            d['entry_money_avg_60']['stock_rights_fund'] = d['entry_money_avg_60']['srf']
            d['entry_money_avg_60']['fund_fixed'] = d['entry_money_avg_60']['ff']

            delete d['d']
            delete d['c']
            delete d['t']
            delete d['cl']
            delete d['pb5']
            delete d['ps5']
            delete d['pb22']
            delete d['ps22']
            delete d['pb']
            delete d['em']
            delete d['ema5']
            delete d['ema22']
            delete d['ema60']

        })

        return data
    }

    const fillTable = useCallback((data) => {
        const updatedData = convertLocalStorageToRealData(data)
        let updatedItems;
        updatedItems = calculates.calculate_ao(updatedData)
        updatedItems = calculates.calculate_percent(updatedData)
        updatedItems = calculates.calculate_equal_weight_percent(updatedData)
        updatedItems = calculates.calculate_alarm(updatedData)

        setRows(updatedItems)
        setItems(updatedItems.slice(0, 100))
    }, [])

    useEffect(() => {
        const localStorageData = JSON.parse(localStorage.getItem('market_users')) || []
        if (localStorageData.length === 0) {
            fetchData()
                .then((response) => {
                    fillTable(response)
                })
                .catch(err => {
                    if (err instanceof Error) {
                        setError(err.message)
                    }
                })
        } else {
            fillTable(localStorageData)
        }

    }, [fillTable])

    return (
        <div>
            <div className="content flex-row-fluid" id="kt_content" dir="rtl">
                <div className="container-fluid mt-lg-0 mt-5">
                    <div className="row">
                        <div className="col-xl-12 d-block">
                            <div className=" h-100">
                                {!error ?
                                    <InfiniteScroll
                                        dataLength={items.length}
                                        next={updateRows}
                                        hasMore={hasMore}
                                        loader={<LoadingSpinner />}
                                        style={{overflow: 'visible'}}
                                    >
                                        <MarketTable config={config} rows={items} filterBy='stock_rights_fund' theme="tb-dark" />
                                    </InfiniteScroll>
                                    :
                                    <div>خطا در دریافت داده - {error}</div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}